import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import Spinner from 'components/Shared/Spinner/Index'
import colors from 'components/utils/colors'

const styleAsDisabled = css`
  pointer-events: none;
`

const styleAsLoading = css`
  pointer-events: none;

  &:before {
    color: transparent !important;
  }
`

const styleAsVertical = css`
  flex-direction: column;
  font-size: 12px;
  text-align: center;
  letter-spacing: 0.01px;
  line-height: 17px;

  &:before {
    margin: 0 0 9px 0;
  }

  span {
    padding: 0 !important;
  }
`

// 'isLoading' is required as 'loading' generates warning about HTML attributes
export const StyledIcon = styled.i`
  display: inline-flex;
  align-items: center;
  color: ${props => props.disabled ? colors.secondary40 : colors.secondary20};
  font-family: Exo;
  font-size: 14px;
  font-weight: 500;

  ${props => props.color && css`
    &:before {
      color: ${props.color};
    }
  `}

  ${props => props.isLoading && styleAsLoading}
  ${props => props.disabled && styleAsDisabled}
  ${props => props.vertical && styleAsVertical}
`

const StyledSpinner = styled(Spinner)`
  position: absolute;
  width: 24px;
  height: 24px;
`

const Text = styled.span`
  user-select: none;
`

const Icon = ({ active, hoverColorGray, disabled, loading, onClick, children, iconName, text, className, hoverable, vertical, color, ...rest }) => {
  const activeClass = active ? '-active' : ''
  const hoverColorGrayClass = hoverColorGray ? '-hoverColorGray' : ''
  const hoverableClass = hoverable ? '' : '-nohover'
  let iconClasses = [className, iconName, activeClass, hoverColorGrayClass, hoverableClass].join(' ')

  if (loading) {
    iconClasses = [className, iconName].join(' ')
  }

  return (
    <>
      {loading && <StyledSpinner size={24} />}
      <StyledIcon
        isLoading={loading}
        onClick={onClick}
        disabled={disabled}
        className={iconClasses}
        vertical={vertical}
        color={color}
        {...rest}
      >
        {text ? <Text>{text}</Text> : children}
      </StyledIcon>
    </>
  )
}

Icon.propTypes = {
  active: PropTypes.bool,
  hoverColorGray: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
  iconName: PropTypes.string.isRequired,
  text: PropTypes.string,
  hoverable: PropTypes.bool,
  vertical: PropTypes.bool,
  color: PropTypes.string,
}

export default Icon
